import './ValueBar.scss'

import cn from 'clsx'

function ValueBar({ className, children }) {
  return <div className={cn('value-bar', className)}>{children}</div>
}

export default ValueBar
